import { FC } from "react";

import { DoctorListingProps } from "./types";
import { Link } from "react-router-dom";



const DoctorsListing: FC<DoctorListingProps> = ({ title, doctorListing }): JSX.Element => {
  return (
    <div className="card h-100">
      <div className="card-header">
        <h4 className="m-0 text-center">{title}</h4>
      </div>

      <div className="card-body p-0">
        <table className="table table-responsive table-hover" >
          <thead className="table-light">
            <tr className="text-center">
              <th>Providers</th>
              <th>Exparel 133mg/10ml vial</th>
              <th>Exparel 266mg/20ml vial</th>
              <th>Total Cases</th>
            </tr>
          </thead>

          <tbody>
            {doctorListing && doctorListing.length > 0 &&
              doctorListing.map((item, key) => (
                <tr className="text-center" key={key}>
                  <td>
                    {/* <Link
                      className="fw-normal fs-6 btn-link link-underline link-underline-opacity-0 link-underline-opacity-75-hover"
                      to={{
                        pathname: `/territories/${item.doctor_id.toString()}`,
                        search: (() => {
                          const newParams = new URLSearchParams()
                          newParams.set("role", "rep");
                          return newParams.toString();
                        })()
                      }}
                      reloadDocument={true}
                    >
                      {item.doctor_name}
                    </Link> */}
                    {item.doctor_name}
                  </td>
                  <td>{item.plan_type_data && item.plan_type_data.length > 0 ? item.plan_type_data[0].count : 0}</td>
                  <td>{item.plan_type_data && item.plan_type_data.length > 1 ? item.plan_type_data[1].count : 0}</td>
                  <td>{item.plan_type_data && item.plan_type_data.length > 0 ? item.plan_type_data[1].cases_total : 0}</td>
                </tr>
              )
            )}
          </tbody>

          {/* <tfoot>
            <tr className="text-center">
              <td className="fw-bold">Total</td>
              <td></td>
              <td className="fw-bold">{total_cases}</td>
            </tr>
          </tfoot> */}
        </table>
      </div>
    </div>
  );
};

export default DoctorsListing;
